import React from 'react';
import { t } from '@lingui/macro';

import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';
import { usePropertyFilledLink } from '$/components/ui/EditableInput/DangerouslySetInnerHTML';

export const HandOutCard: React.FC = () => {
  const { interaction } = useCardContext();

  const detailLink = usePropertyFilledLink(interaction.details?.link);

  if (!interaction.details) return null;
  const { buttonText } = interaction.details;

  return (
    <>
      {(detailLink || Boolean(interaction?.fragmentForEdit?.templateId)) && (
        <CardMain.SubmitButton>{buttonText || t`Go`}</CardMain.SubmitButton>
      )}
    </>
  );
};
